<template>
  <div class="sidebar-menu">
    <div class="SPG-logo" @click="goToHome">
      <!-- <img src="https://pic1.imgdb.cn/item/68f352683203f7be007b4574.svg" alt="logo"/> -->
      <div class="logo"></div>
    </div>
    <!-- 菜单图标按钮 - 固定在右上角 -->
    <button 
      class="menu-toggle" 
      @click="toggleMenu"
      :class="{ 'active': isMenuOpen }"
      aria-label="打开菜单"
    >
      <i class="icon" :class="isMenuOpen ? 'icon-close' : 'icon-menu'"></i>
    </button>
    
    <!-- 半透明遮罩层 -->
    <div 
      class="menu-overlay" 
      v-if="isMenuOpen"
      @click="closeMenu"
    ></div>
    
    <!-- 侧边菜单 -->
    <div 
      class="menu-panel" 
      :class="{ 'menu-open': isMenuOpen }"
    >
      <ul class="menu-list">
        <li
          v-for="(item, index) in menuData" 
          :key="index" 
          class="menu-item"
        >
          <!-- 菜单项（一级菜单） -->
          <div class="menu-link" @click="handleMenuItemClick(item)" :class="{ 'active': isActive(item) }">
            <span>{{ item.name }}</span>
            <!-- 有子菜单时显示箭头 -->
            <i 
              class="arrow-icon" 
              v-if="item.children && item.children.length"
              :class="{ 'rotate': item.isOpen }"
            ></i>
          </div>
          
          <!-- 子菜单 -->
          <ul 
            class="submenu" 
            v-if="item.children && item.children.length"
            :class="{ 'submenu-open': item.isOpen }"
          >
            <li 
              v-for="(child, cIndex) in item.children" 
              :key="cIndex" 
              class="submenu-item"
            >
              <router-link 
                :to="item.path + '/' + child.path"
                class="submenu-link"
                @click.native="closeMenu"
                :class="{ 'active': isSubActive(item, child) }"
              >
                {{ child.name }}
              </router-link>
            </li>
          </ul>
        </li>


      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'SidebarMenu',
  data() {
    return {
      isMenuOpen: false, // 控制菜单是否打开
      menuData: [
        {
          'name':'首页',
          'path':'/'
        },
        {
          name: '关于我们',
          path: '/aboutus', // 关键：必须与路由中父路径一致
          children: [
            { name: '集团介绍', path: 'aboutusView' },
            { name: '品牌文化', path: 'CorporateCulture' },
            { name: '品牌历程', path: 'BrandHistory' },
            { name: '推广宣传', path: 'BrandAd' }
          ]
        },
        {
          'name':'集团新闻',
          'path':'/NewsView'
        },
        {
          'name':'5X产品',
          'path':'/ProductShowcase',
          children: [
            { name: '茶业系列', path: '#tea' },
            { name: '茶饮系列', path: '#drink' },
            { name: '茶器系列', path: '#set' },
            { name: '茶宴系列', path: '#party' },
            { name: '茶舱系列', path: '#capsule' }
          ]
        },
        {
          'name':'集团管控',
          'path':'/controlView'
        },
        {
          'name':'人才招纳',
          'path':'/jobRecruitment'
        },
        {
          'name':'社会责任',
          'path':'/socialResponsibility',
          children: [
            { name: '公益帮扶助力', path: 'publicWelfareView' },
            // { name: '三农优选计划', path: 'agricultureView' },
            // { name: '乡村振兴战略', path: 'countryView' },
            // { name: '健康中国品牌', path: 'healthyView' }
          ]
        },
        {
          'name':'联系我们',
          'path':'/ContactView'
        }
      ]
    };
  },
  mounted() {
    // 初始化 wow 动画
    this.$wow.init()
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
    // 初始化时触发一次，确保初始状态正确
    this.handleScroll();
  },
  methods: {
    // 判断一级菜单是否活跃
    isActive(item) {
      // 没有子菜单的项直接匹配路径
      if (!item.children || !item.children.length) {
        return this.$route.path === item.path;
      }
      // 有子菜单的项匹配子路径前缀
      return this.$route.path.startsWith(item.path);
    },
    
    // 判断子菜单是否活跃
    isSubActive(parent, child) {
      const fullPath = `${parent.path}/${child.path}`;
      return this.$route.path === fullPath;
    },
    goToHome() {
      // 方法中使用 this.$router.push
      this.$router.push('/');
    },
    getTargetPath(menuItem, isChild = false) {
      // 如果是子菜单（二级路由），则拼接父路径
      if (isChild) {
        // 父路径（item.path）+ 子路径（menuItem.path）
        return `${menuItem.parentPath}/${menuItem.path}`;
      }
      // 如果是一级路由（无论有无子菜单），直接返回自身绝对路径
      return menuItem.path;
    },
    handleScroll() {
      const menu = document.querySelector('.sidebar-menu');
      menu.classList.toggle('has-bg', window.scrollY > 50); // 滚动超过50px时添加has-bg
      const sidebarMenu = document.querySelector('.sidebar-menu');
      // 当滚动距离 > 50px 时，添加背景；否则移除
      if (window.scrollY > 50) {
        sidebarMenu.classList.add('has-bg');
      } else {
        sidebarMenu.classList.remove('has-bg');
      }
    },
    // 切换菜单开关状态
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      // 控制页面滚动
      document.body.style.overflow = this.isMenuOpen ? 'hidden' : '';
    },
    
    // 关闭菜单
    closeMenu() {
      this.isMenuOpen = false;
      document.body.style.overflow = '';
      // 重置所有子菜单状态
      this.menuData.forEach(item => {
        item.isOpen = false;
      });
    },
    
    // 处理菜单项点击
    handleMenuItemClick(item) {
      // 如果有子菜单，切换子菜单展开状态
      if (item.children && item.children.length) {
        this.$set(item, 'isOpen', !item.isOpen);
      } else {
        // 没有子菜单则跳转并关闭菜单
        this.$router.push(item.path);
        this.closeMenu();
      }
    },
    
    // 处理子菜单项点击
    handleSubmenuClick(child) {
      this.$router.push(child.path);
      this.closeMenu();
    }
  },
  // 组件销毁时恢复页面滚动
  beforeDestroy() {
    document.body.style.overflow = '';
    window.removeEventListener('scroll', this.handleScroll);
  }
});
</script>

<style scoped>

.sidebar-menu {
	position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 66px;
  z-index: 999;
  display: flex;
  align-items: center;
  padding: 0 15px;
  color: #fff;
  transition: background-color 0.3s ease;
  box-sizing: border-box;
}
.sidebar-menu.has-bg {
  backdrop-filter: blur(10px);
  background-color: rgba(230, 0, 18, 0.75);
  box-shadow: 0 4px 15px rgba(230, 0, 18, 0.1);
}
/* 菜单按钮样式 - 固定在右上角 */
.menu-toggle {
  position: absolute;
  top: 11px;
  right: 10px;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0);
  color: white;
  border: none;
  z-index: 65;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.menu-toggle.active {
  background-color: rgba(0, 0, 0, 0.35);
}

.menu-toggle i{background: #303133;}
.menu-toggle i::after,.menu-toggle i::before{background: #303133;}
.menu-toggle .icon-close{background: none;}
.menu-toggle .icon-close::after,.menu-toggle .icon-close::before{background: #ffffff;}

/* 菜单图标样式 */
.icon {
  display: block;
  width: 24px;
  height: 2.5px;
  background-color: white;
  position: relative;
  transition: all 0.3s ease;
}

.icon::before,
.icon::after {
  content: '';
  position: absolute;
  width: 24px;
  height: 2.5px;
  background-color: white;
  left: 0;
  transition: all 0.3s ease;
}

.icon-menu::before {
  top: -8px;
}

.icon-menu::after {
  bottom: -8px;
}

/* 关闭图标样式 */
.icon-close {
  background-color: transparent;
}

.icon-close::before {
  top: 0;
  transform: rotate(45deg);
}

.icon-close::after {
  bottom: 0;
  transform: rotate(-45deg);
}

/* 遮罩层样式 */
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 40;
  opacity: 0;
  animation: fadeIn 0.3s forwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 侧边菜单面板样式 */
.menu-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 80%;
  max-width: 300px;
  height: 100vh;
  background-color: rgba(255,255,255,.95);
  z-index: 60;
  transform: translateX(100%);
  transition: transform 0.3s ease-out;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* 平滑滚动 */
}
.menu-panel .menu-item .active{
  border-left: 3px solid #e60012;
  background: #e6001217;
  color: #e60012;
  padding-left: 17px;
}

/* 菜单打开状态 */
.menu-open {
  transform: translateX(0);
}

/* 菜单列表样式 */
.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 70px; /* 留出顶部空间 */
}

/* 菜单项样式 */
.menu-item {
  border-bottom: 1px solid #f0f0f0;
}

.menu-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  color: #303133;
  text-decoration: none;
  font-size: .6rem;
  cursor: pointer;
  font-weight: bold;
}

/* 箭头图标样式 */
.arrow-icon {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-right: 2px solid #999;
  border-bottom: 2px solid #999;
  transform: rotate(-45deg);
  transition: transform 0.3s ease;
}

.arrow-icon.rotate {
  transform: rotate(45deg);
}

/* 子菜单样式 */
.submenu {
  list-style: none;
  padding: 0;
  margin: 0;
  /* background-color: #f9f9f9; */
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.submenu-open {
  max-height: 500px; /* 足够大的值来容纳子菜单 */
}

.submenu-item {
  border-bottom: 1px solid #eee;
}

.submenu-link {
  display: block;
  padding: 14px 20px 14px 20px; /* 缩进显示层级 */
  color: #666;
  text-decoration: none;
  font-size: 0.6rem;
  transition: background-color 0.2s;
  text-align: left;
}

.submenu-link:hover {
  background-color: #f0f0f0;
}
.SPG-logo {
	position: absolute;
  z-index: 60;
  width: 90px;
  height: 46px;
  top: 12px;
  left: 20px;
}
.SPG-logo img {
	width: 100%;
	height: auto;
}
/* 顶部菜单基础样式 */
.sidebar-menu {
  position: fixed;
  top: 0;
  width: 100%;
  height: 68px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  transition: all 0.3s ease;
}

/* logo 基础样式（固定大小和位置） */
.logo {
  width: 90px; /* 根据实际 logo 大小调整 */
  height: 46px;
  background-size: contain; /* 图片自适应容器 */
  background-repeat: no-repeat;
  background-position: center;
}

/* 无背景时的 logo（默认状态） */
.sidebar-menu:not(.has-bg) .logo {
  background-image: url('https://www.3pg.cn/img/SPG-logo.69011225.svg');
}

/* 有背景时的 logo（添加 has-bg 类时） */
.sidebar-menu.has-bg .logo {
  background-image: url('https://7765-web-2gpx1p8e8259ddd9-1253923329.tcb.qcloud.la/tcb_upload/1771639177256_np205tsb.svg');
}

/* 其他样式（之前的玻璃态背景） */
.sidebar-menu {
  /* backdrop-filter: blur(8px); */
  /* -webkit-backdrop-filter: blur(8px); */
  background-color: transparent; /* 初始无背景 */
}
.sidebar-menu.has-bg {
  background-color: rgba(230, 0, 18, 0.85); /* 有背景时的红色毛玻璃 */
}
.sidebar-menu.has-bg .menu-toggle i{background: white;}
.sidebar-menu.has-bg .menu-toggle i::after,.sidebar-menu.has-bg .menu-toggle i::before{background: white;}

</style>
